module.exports = __webpack_public_path__ + "img/icons B_37.e3520020.svg";